import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllProjects,
  getAllUsersInProject,
  getProjectInfo
} from '../../api/project-registers';
import { User } from '../UserProfile/userProfileSlice';

export const getProjectRegistersAsync = createAsyncThunk(
  'projectRegisters/getProjects',
  getAllProjects
);

export const getProjectRegisterInfoAsync = createAsyncThunk(
  'projectRegisters/getProjectInfo',
  getProjectInfo
);

export const getUsersInProjectRegisterAsync = createAsyncThunk(
  'projectRegisters/getUsers',
  getAllUsersInProject
);

export interface ProjectRegister {
  id: number;
  projectNo?: string;
  name: string;
  plantName: string;
  customerCompanyName: string;
  productName: string;
  businessUnitName: string;
  businessUnitGroupName: string;
  projectStatus: string;
}

interface ProjectRegisterState {
  projects: ProjectRegister[];
  project: ProjectRegister | null;
  users: User[];
}

const initialState: ProjectRegisterState = {
  projects: [],
  project: null,
  users: []
};

export default createSlice({
  name: 'projectRegisters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProjectRegistersAsync.fulfilled, (state, action) => {
      state.projects = action.payload.data;
    });
    builder.addCase(getProjectRegisterInfoAsync.fulfilled, (state, action) => {
      state.project = action.payload;
    });
    builder.addCase(
      getUsersInProjectRegisterAsync.fulfilled,
      (state, action) => {
        state.users = action.payload.data;
      }
    );
  }
});
